import {Pipe, PipeTransform} from '@angular/core';
import {IEntity} from '@app/views/databrowsing/model/common.data.models';
import {BrowserEntityView} from '@app/views/databrowsing/browser-entity-view';

@Pipe({
    name: 'filterSchoolsTab'
})
export class FilterSchoolsTabPipe implements PipeTransform {

    transform(entityViews: BrowserEntityView<IEntity>[], hideSchoolsTab: boolean): BrowserEntityView<IEntity>[] {
        return hideSchoolsTab && entityViews
            ? entityViews.filter((tabEntity: BrowserEntityView<IEntity>) => tabEntity.eduToneEntity !== 'School')
            : entityViews;
    }

}
